const Routes = {
  login: { path: '/login', title: 'Login' },
  home: { path: '/home', title: 'Home' },
  users: { path: '/users', title: 'Users' },
  userEdit: { path: '/user/edit/:userId', title: 'User Edit' },
  userReports: {
    path: '/user-reports',
    title: 'User Reports',
  },
  cities: { path: '/cities', title: 'Cities' },
  countries: { path: '/countries', title: 'Countries' },
  spots: { path: '/spots', title: 'Spots' },
  spotsEdit: {
    path: '/spots/edit/:spotId',
    title: 'Edit Spot',
    backPath: '/spots',
  },
  spotsInteractiveEdit: {
    path: '/spots/interactive-edit/:spotId',
    title: 'Interactive Edit Spot',
    backPath: '/spots',
  },
  recommendations: { path: '/recommendations', title: 'Recommendations' },
  recommendationsEdit: {
    path: '/recommendations/edit/:recommendationId',
    title: 'Recommendation Edit',
  },
  lists: { path: '/lists', title: 'Lists' },
  benefits: { path: '/benefits', title: 'Benefits' },
  benefitsCategories: {
    path: '/benefits/categories',
    title: 'Benefit Categories',
    backPath: '/benefits',
  },
  benefitsCategoryCreate: {
    path: '/benefits/categories/create',
    title: 'Create Category',
    backPath: '/benefits/categories',
  },
  benefitsCategoryEdit: {
    path: '/benefits/categories/edit/:categoryId',
    title: 'Edit Category',
    backPath: '/benefits/categories',
  },
  benefitsCreate: {
    path: '/benefits/create',
    title: 'Create Benefit',
    backPath: '/benefits',
  },
  benefitsEdit: {
    path: '/benefits/edit/:benefitId',
    title: 'Edit Benefit',
    backPath: '/benefits',
  },
  notifications: { path: '/notifications', title: 'Notifications' },
  notificationCreate: {
    path: '/notification/create',
    title: 'Notification Create',
    backPath: '/notifications',
  },
  autoNotification: {
    path: '/auto-notification',
    title: 'Auto Notification',
  },
  autoNotificationEdit: {
    path: '/auto-notification/edit/:notifId',
    title: 'Auto Notification Edit',
    backPath: '/auto-notification',
  },
  autoNotificationReport: {
    path: '/auto-notification/report',
    title: 'Auto Notification Report',
    backPath: '/auto-notification',
  },
  autoNotificationReportDetail: {
    path: '/auto-notification/detail/:notifId',
    title: 'Auto Notification Detail',
    backPath: '/auto-notification/report',
  },
  businessOwner: { path: '/business-owner', title: 'Business Owner' },
  links: { path: '/links', title: 'Links' },
  webHooks: { path: '/web-hooks', title: 'Web Hooks' },
  default: { path: '/home', title: 'Home' },
};

export default Routes;
